export const protectedRoutes = ["/wallet", "/currency-faqs", "/payments"];

export const publicRoutes = [
  "/campaign",
  "/delete-account-faq",
  "/download",
  "/gamification",
  "/grievance",
  "/kitchen-ministers",
  "/knowledge-saptah",
  "/marketplace-tc",
  "/moj-for-creators",
  "/opt-in",
  "/payments",
  "/wallet",
  "/currency-faqs",
  "/request-account-delete",
  "/stories",
];

export const ROUTES_WITHOUT_REDIRECTION = [
  ...protectedRoutes,
  ...publicRoutes,
  "/login",
  "/live-web",
  "/livestream",
  "/wiki",
  "/embed",
  "/opt-in/monetization-policy",
  "/opt-in/status",
  "/opt-in",
  "/gaming-on-moj",
  "/account-deleted-relogin",
  "/short-video-app",
  "/404",
  "/redirect",
];
